import { Button, ButtonsGroup, Modal, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useVatExemptionMentionModalForm } from '../../context/vatExemptionMentionModalFormContext'

interface VatExemptionMentionModalFooterProps {
  id: string
  isSubmitting: boolean
}

export const VatExemptionMentionModalFooter = ({
  id,
  isSubmitting = false,
}: VatExemptionMentionModalFooterProps): ReactElement => {
  const { t } = useTranslation()
  const { submitForm } = useVatExemptionMentionModalForm()
  const { close: closeModal } = useModal(id)

  const handleCancelButtonClick = useCallback(() => {
    closeModal()
  }, [closeModal])

  const handleSaveButtonClick = useCallback(() => {
    submitForm()
  }, [submitForm])

  return (
    <Modal.Footer>
      <ButtonsGroup>
        <Button onClick={handleCancelButtonClick} variant="text">
          {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.cancel')}
        </Button>
        <Button disabled={isSubmitting} loading={isSubmitting} onClick={handleSaveButtonClick}>
          {t('settings.organization.external_invoice.general.vat_exemption_mention.modal.save')}
        </Button>
      </ButtonsGroup>
    </Modal.Footer>
  )
}
